import { useTranslation } from "react-i18next";

const Pricing = () => {
  const { t } = useTranslation();

  const plans = [
    {
      key: "free",
      price: "FREE",
      icon: "bi-box",
      featured: false,
    },
    {
      key: "basic",
      price: "30 RON",
      icon: "bi-rocket",
      featured: true,
    },
    {
      key: "pro",
      price: "50 RON",
      icon: "bi-send",
      featured: false,
    },
  ];

  return (
    <section id="pricing" className="pricing section">
      <div className="container section-title" data-aos="fade-up">
        <h2>{t("pricing.title")}</h2>
        <p>{t("pricing.description")}</p>
      </div>

      <div className="container" data-aos="zoom-in" data-aos-delay="100">
        <div className="row g-4">
          {plans.map((plan, idx) => {
            const planData = t(`pricing.plans.${plan.key}`, {
              returnObjects: true,
            });

            return (
              <div className="col-lg-4" key={idx}>
                <div
                  className={`pricing-item d-flex flex-column h-100 ${
                    plan.featured ? "featured" : ""
                  }`}
                >
                  <h3>{planData.name}</h3>
                  <div className="icon">
                    <i className={`bi ${plan.icon}`}></i>
                  </div>
                  <h4>
                    {plan.price}
                    {plan.price !== "FREE" && <span> / {t("month")}</span>}
                  </h4>
                  <ul>
                    {planData.features.map((feat, i) => (
                      <li key={`f-${i}`}>
                        <i className="bi bi-check"></i> <span>{feat}</span>
                      </li>
                    ))}
                    {planData.disabled?.map((feat, i) => (
                      <li className="na" key={`na-${i}`}>
                        <i className="bi bi-x"></i> <span>{feat}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="text-center">
                    <a href="#" className="buy-btn">
                      {planData.button}
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
